import { useCallback } from "react"
import constants from './constants'
import { useDispatch } from "react-redux"
import { initialize, reset } from "redux-form"

const useCleanForm = () => {
    const dispatch = useDispatch()
    const { formname } = constants

    const cleanForm = useCallback(() => {
        dispatch(reset(formname))
        dispatch(initialize(formname, {}));
    }, [])

    return cleanForm
}
export default useCleanForm